import React from 'react';
import Block from './Block';
import BarChart from './BarChart';

/**
 * Renders a `correlation_block` from compute_correlations. Backend supplies
 * { top_pairs: [{col1, col2, value}, ...], method: "MIC"|"pearson" }.
 */
const CorrelationBlock = ({ blockData = {} }) => {
  const top = (blockData.top_pairs || []).slice(0, 10).map(p => ({
    label: `${p.col1} ↔ ${p.col2}`,
    value: Math.abs(Number(p.value || 0)),
  }));
  return (
    <Block icon="git-branch" title={`Top correlations${blockData.method ? ` (${blockData.method})` : ''}`}>
      <BarChart data={top} valueFormat={(v) => v.toFixed(2)} max={1} />
    </Block>
  );
};

export default CorrelationBlock;
